import type { TFunction } from 'i18next';

import { ScheduleRunItemReason, type ScheduleRunItem } from '@nucleus-commerce/api-client/admin';

const REASONS: ReadonlySet<string> = new Set(Object.values(ScheduleRunItemReason));

/**
 * Why a run did something to one product in one store. The reason is one of the schedule's own
 * reasons or, for an item that failed and was recorded as a skip, an API error code.
 */
export function runItemReasonLabel(t: TFunction, reason: ScheduleRunItem['reason']): string | null {
  if (reason === null) return null;
  if (REASONS.has(reason)) return t(`schedules:reason.${reason}`);
  return t('schedules:reason.failed', { message: t(`errors:code.${reason}`) });
}
